import { Logo } from "@/components/Logo";

const CAR_IMG =
  "https://customer-assets-lqy194kg.emergentagent.net/job_guard-care-portal/artifacts/zbvqpwjw_84959f6a-5a5d-49c1-943a-fa0206c0c646-2026-07-17.png";

export function AuthShell({ children }) {
  return (
    <div className="sg-noise flex min-h-screen bg-[#0A0A0A]">
      {/* Left: form */}
      <div className="relative z-10 flex w-full flex-col justify-center px-6 py-10 sm:px-12 lg:w-[46%] lg:px-20">
        <div className="mx-auto w-full max-w-md">
          <div className="mb-10 h-14">
            <Logo className="h-14" />
          </div>
          {children}
          <p className="mt-10 text-xs text-neutral-600">
            © {new Date().getFullYear()} SGBINOXE. Internal platform for authorised installers.
          </p>
        </div>
      </div>

      {/* Right: imagery */}
      <div className="relative hidden lg:block lg:w-[54%]">
        <img
          src={CAR_IMG}
          alt="SGBINOXE protected vehicle"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A] via-[#0A0A0A]/40 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-transparent to-transparent" />
        <div className="absolute bottom-16 left-16 right-16">
          <div className="h-[2px] w-16 bg-[#E30613]" />
          <h2 className="mt-6 font-display text-4xl font-semibold leading-tight tracking-tight text-white">
            Precision protection,<br />managed with care.
          </h2>
          <p className="mt-4 max-w-md text-base leading-relaxed text-neutral-400">
            Certificates, activations and installations — the complete SGBINOXE installer
            operating system.
          </p>
        </div>
      </div>
    </div>
  );
}
